import * as React from "react";
import { forwardRef } from "react";
const SvgCell = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    ref={ref}
    {...props}
  >
    <path d="M85.712 16.683H100v66.634H85.712ZM64.274 27.782h14.288v55.535H64.274ZM42.849 38.894h14.288v44.423H42.849Zm-21.41 11.1h14.287v33.323H21.438ZM0 61.091h14.288v22.211H0Z" />
  </svg>
);
const ForwardRef = forwardRef(SvgCell);
export default ForwardRef;
